// style.js
import { styled } from '@mui/system';

export const ContentWrapper = styled('div')(`
    font-size: 14px;
    color: #333333;
    line-height: 1.6;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    padding: 0 16px 12px 16px;
    margin-top:-8px;

    &#prismInsights__undefined__undefined {
        display: none;
    }
`);

export const BulletList = styled('ul')(`
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
`);

export const BulletItem = styled('li')(`
    margin-bottom: 6px;
    &::marker {
        color: #555555;
    }
`);

export const FilterLabel = styled('span')(`
    font-weight: 600;
    color: #222222;
`);